module.exports = __webpack_public_path__ + "img/treppegelaender_tuer.c56c04e9.jpg";